import { useLocation } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { isItemActive } from '../SidebarItem/SidebarItem';

export const hasActiveChild = (currentPathname, children = []) => {
  return children.some((child) =>
    isItemActive(currentPathname, child.path, child.matchPaths)
  );
};

const SidebarGroup = ({ item, isOpen, onToggle }) => {
  const { pathname } = useLocation();
  const childrenActive = hasActiveChild(pathname, item.children);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const hideTimer = useRef(null);

  useEffect(() => {
    return () => {
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    if (document.body.classList.contains('menu-active') && window.innerWidth > 1024) return;
    onToggle();
  };

  const handleMouseEnter = () => {
    if (!document.body.classList.contains('menu-active')) return;
    if (hideTimer.current) clearTimeout(hideTimer.current);
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    if (!document.body.classList.contains('menu-active')) return;
    hideTimer.current = setTimeout(() => setTooltipVisible(false), 150);
  };

  const groupClassName = [
    'sidebar-item',
    'sidebar-link',
    'has-sub',
    childrenActive || isOpen ? 'active' : '',
    isOpen ? 'is-open' : ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <li
      className={groupClassName}
      id={item.id}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#" onClick={handleClick}>
        {item.icon && <span className={item.icon} />}
        <span>{item.label}</span>
      </a>

      <ul
        className={`sidebar-sub${isOpen ? ' is-open' : ''}${tooltipVisible ? ' tooltip-open' : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}>
        <li className="sidebar-sub-header">{item.label}</li>
        {item.children.map((child) => {
          const active = isItemActive(pathname, child.path, child.matchPaths);
          return (
            <li
              key={child.id}
              className={`sidebar-item sidebar-link${active ? ' active' : ''}`}
              id={child.id}>
              <a href={child.path} className={active ? 'curent' : ''}>
                {child.label}
              </a>
            </li>
          );
        })}
      </ul>
    </li>
  );
};

export default SidebarGroup;
